export const Types = {
  GET_REQUEST: 'settings/GET_REQUEST',
  GET_SUCCESS: 'settings/GET_SUCCESS',
  GET_FAILURE: 'settings/GET_FAILURE',

  GET_LIST_REQUEST: 'settings/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'settings/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'settings/GET_LIST_FAILURE',

  UPDATE_REQUEST: 'settings/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'settings/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'settings/UPDATE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  update: {
    loading: false,
  },
};

export default function settings(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.setting.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.settings.data,
        page: action.payload.settings.meta.current_page,
        totals: action.payload.settings.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.UPDATE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getSettingRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getSettingSuccess: setting => ({
    type: Types.GET_SUCCESS,
    payload: { setting },
  }),

  getSettingFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getSettingsRequest: (page = 1, filter = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filter },
  }),

  getSettingsSuccess: settings => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { settings },
  }),

  getSettingsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  updateSettingRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateSettingSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateSettingFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),
};

// export const Selectors = {
//   roles: createSelector(
//     state => state,
//     roles => roles.map(role => ({ value: role.id, label: role.attributes.title })),
//   ),
// };
